import { AbstractControl } from '@angular/forms';

export function validateLatitude(): (control: AbstractControl) => any{
  return validateCoordinates({validLetters: ['N', 'S'], min: -90, max: 90});
}

export function validateLongitude(): (control: AbstractControl) => any{
  return validateCoordinates({validLetters: ['E', 'W'], min: -180, max: 180});
}

interface IConfig{
  validLetters: string[];
  max: number;
  min: number;
}

function validateCoordinates({validLetters, max, min}: IConfig): (control: AbstractControl) => any{
  const degreesFormat = /^([0-9]+)°\s*([0-9]+)[′']\s*([0-9]+)[″"]\s*([NSEW])$/i;

  return (control: AbstractControl): {[key: string]: any} => {
    const strValue = control.value;
    let valid = false;

    if (!isNaN(strValue)){
      const numValue = +strValue;
      valid = strValue >= min && strValue <= max;
    }else{
      const matches = degreesFormat.exec(strValue);

      if (matches){
        const degrees = +matches[1];
        const minutes = +matches[2];
        const seconds = +matches[3];
        const letter = matches[4];

        valid = !isNaN(degrees) && degrees >= min && degrees <= max &&
          !isNaN(minutes) && minutes >=0 && minutes < 60 &&
          !isNaN(seconds) && seconds >= 0 && seconds < 60 &&
          validLetters.indexOf(letter.toUpperCase()) >= 0;
      }
    }

    return !valid ? {'coordinates': {value: control.value}} : null;
  };
}